import { useLocation } from "react-router-dom";
import CustomTitle from "../../../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../../services/api.service";
import TableView from "../../../Common/TableView";
import { TratamentoConfig } from "./Tratamento.config";


export default function Tratamento() {


    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];

    const EXTENSION = `/obras/${obraId}/pecas/${pecaId}/operacoes/Tratamento`;

    return(<>{EXTENSION?<div>
        <CustomTitle small text={'Operações de Tratamento'}/>
        <TableView 
        title={"Operações de Tratamento"}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Operação"} 
        searchButtonText={"Procurar Operação"}
        tableConfigs={TratamentoConfig}
        dataBuildFunction={generalObjectBuilder(TratamentoConfig)}
        entityName={"Operações Tratamento"}
        idProp={"id"}
        configMapKey={`obras/${obraId}/pecas/${pecaId}/operacoes/Tratamento`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)

}